module.exports = __webpack_public_path__ + "static/media/pyramid-side.36911826.png";